export default "__VITE_ASSET__DYiXZtlt__"